
<template  minapp='mpx' xlang='wxml'>
  <es-drawer-bottom
    title="退票详情"
    show="{{show}}"
    showDefaultNav
    bind:close="closeRefundDetail"
    class="main"
    navbarStyle="{{curNavBarStyle}}"
    customStyle="{{curCustomStyle}}"
  >
    <view class="list-content" wx:if="{{refundDetail}}">
      <view class="normal-item">
        <view class="left">退票人</view>
        <view class="right">{{refundDetail.passenger_name}}</view>
      </view>
      <view class="normal-item">
        <view class="left">退票行程</view>
        <view class="right-flight">
          <view class="right-city">
            <view>{{refundDetail.from_station_name}}</view>
            <es-icon class="city-arrow" name="arrow-switch-right" size="13" />
            <view>{{refundDetail.to_station_name}}</view>
          </view>
          <view class="train-time">{{refundTicketTime}}</view>
        </view>
      </view>
      <view class="normal-item">
        <view class="left">退票原因</view>
        <view class="right">{{refundDetail.reason}}</view>
      </view>
      <view class="normal-item">
        <view class="left">退票时间</view>
        <view class="right">{{refundTime}}</view>
      </view>
    </view>
  </es-drawer-bottom>
</template>

<script>
  import { createComponent, mpx } from '@didi/es-mpx-creator'
  import { formatDate, parseDate } from '@/utils/baseDate'

  createComponent({
    props: {
      show: {
        type: Boolean,
        value: false
      },
      refundDetail: Object
    },
    data() {},
    watch: {},
    computed: {
      curCustomStyle() {
        return {
          ...this.customStyle,
          background: '#f0f1f4'
        }
      },
      curNavBarStyle() {
        return {
          background: '#f0f1f4'
        }
      },
      refundTime() {
        return formatDate(
          this.refundDetail?.refund_time * 1000,
          'YYYY-MM-dd hh:mm'
        )
      },
      refundTicketTime() {
        return formatDate(
          this.refundDetail?.start_time * 1000,
          'YYYY-MM-dd hh:mm'
        )
      }
    },
    methods: {
      closeRefundDetail() {
        this.$trigger('close', null)
      }
    },
    beforeCreate() {},

    created() {},

    mounted() {},

    destroyed() {}
  })
</script>

<style lang='stylus' scoped>
  @import '~@/mixins/stylus/color.styl'

  .main
    /deep/ .es-navbar
      background-color $train-color-background
    /deep/ .drawer-container
      overflow auto
  .list-content
    margin 10px 12px
    padding 17px 12px
    background-color #ffffff
    border-radius 8px
    display flex
    flex-direction column
  .normal-item
    display flex
    margin-bottom 12px
    justify-content flex-start
    align-items flex-start
  .left
    flex 0 0 73px
    color $train-color-light-gray
    font-size 14px
    // white-space nowrap
  .right
    flex 1
    color $train-color-dark-gray
    font-size 14px
    line-height 20px
  .right-flight
    display flex
    flex-direction column
  .right-city
    display flex
    font-size 14px
  .city-arrow
    margin-left 4px
    margin-right 4px
    margin-top 4px
  .train-time
    color $train-color-light-gray
    font-size 12px
</style>

<script name='json'>
  module.exports = {
    component: true,
    usingComponents: {
      'es-icon': '@didi/es-mpx-ui/lib/icon',
      'es-drawer-bottom': '@didi/es-mpx-ui/lib/drawer-bottom'
    }
  }
</script>